import { MovieStreamFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getNotNullableItems } from '@/scenarios/legacy-player/lib/get-not-nullable-items';

import { transformAudio } from '../../movie-player/transformers/transform-audio';

export const getChannelAudio = (stream: MovieStreamFragment | null) => {
    const audio = getNotNullableItems(stream?.streamMeta?.audioMetas);

    return transformAudio(audio);
};
